import React, { useId } from 'react';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';

export const supplierDisplayName = supplier => supplier.typeFournisseur === 'ENTREPRISE'
    ? (supplier.entreprise || '') : [supplier.nom, supplier.prenom].filter(Boolean).join(' ');

export default function SupplierInfoFields({ supplier, onChange, errors = {}, disabled = false }) {
    const id = useId();
    const nameError = errors.name || errors.nom || errors.entreprise;
    return <Row className="g-3">
        <Col md={6}><FormGroup><Label for={`${id}-name`}>Nom du fournisseur *</Label>
            <Input id={`${id}-name`} name="supplierName" value={supplierDisplayName(supplier)} placeholder="Nom complet ou nom du commerce" disabled={disabled} invalid={Boolean(nameError)}
                onChange={event => { const value = event.target.value; onChange(current => current.typeFournisseur === 'ENTREPRISE' ? { ...current, entreprise: value } : { ...current, nom: value, prenom: '' }); }} />
            {nameError && <div className="invalid-feedback">{nameError}</div>}
        </FormGroup></Col>
        <Col md={6}><FormGroup><Label for={`${id}-phone`}>Téléphone</Label>
            <Input id={`${id}-phone`} name="telephone1" type="tel" value={supplier.telephone1 || ''} placeholder="06 12 34 56 78" disabled={disabled}
                onChange={event => { const value = event.target.value; onChange(current => ({ ...current, telephone1: value })); }} />
        </FormGroup></Col>
        <Col md={6}><FormGroup><Label for={`${id}-address`}>Adresse</Label>
            <Input id={`${id}-address`} name="adresse" value={supplier.adresse || ''} placeholder="Rue, quartier ou ville" disabled={disabled}
                onChange={event => { const value = event.target.value; onChange(current => ({ ...current, adresse: value })); }} />
        </FormGroup></Col>
        <Col md={6}><FormGroup><Label for={`${id}-ice`}>ICE</Label>
            <Input id={`${id}-ice`} name="ice" type="text" inputMode="numeric" value={supplier.ice || ''} placeholder="Numéro ICE" disabled={disabled}
                onChange={event => { const value = event.target.value; onChange(current => ({ ...current, ice: value })); }} />
        </FormGroup></Col>
    </Row>;
}
